import { TrendingUp } from 'lucide-react'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const DevelopmentPlansPage = lazyPage(() => import('@/pages/DevelopmentPlans'), 'DevelopmentPlansPage')

export const developmentPlanModule: ModuleDefinition = {
  key: 'developmentPlan',
  icon: TrendingUp,
  iconName: 'trending-up',
  namespaces: ['developmentPlans'],
  ready: true,
  opensOnCreate: true,
  /* The place where each person keeps their own plan (Meu PDI, Meu time, Para aprovar, Painel).
     No "one or many" step and nothing to configure: the wizard creates it straight away (F-52 criterion 1). */
  ListPage: DevelopmentPlansPage,
  workflow: {
    trigger: { block: 'pdi', hrPrefixes: ['development_plan.', 'time.pdi_'] },
    spaceActions: ['developmentPlan.action.add']
  }
}
